import { render, staticRenderFns } from "./How-it-works.vue?vue&type=template&id=7920dec4&scoped=true"
import script from "./How-it-works.vue?vue&type=script&lang=js"
export * from "./How-it-works.vue?vue&type=script&lang=js"
import style0 from "./How-it-works.vue?vue&type=style&index=0&id=7920dec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920dec4",
  null
  
)

export default component.exports